export const convertToMarathiNumber = (number) => {
    const marathiDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return number
        .toString()
        .split('')
        .map(digit => marathiDigits[Number.parseInt(digit, 10)])
        .join('');
};
